import {useState} from 'react'
import {InnerAvatar} from '../inner_avatar'

export const ImageAvatar = ({imageSrc, fallback, ...rest}) => {
	const [imageError, setImageError] = useState(false)

	const handleImageError = () => {
		setImageError(true)
	}

	if (imageError && fallback) return fallback

	return (
		<InnerAvatar colorSet="grey-bordered" {...rest}>
			<img src={imageSrc} onError={handleImageError} alt="" />
		</InnerAvatar>
	)
}
